import PropTypes from 'prop-types'
import React, { useState } from 'react'
import RadioButtonButton from './RadioButtonButton'

// eslint-disable-next-line no-unused-vars
const ButtonToggle = React.forwardRef((props, ref) => {
  const { name, textOn, textOff, checked, disabled, onChange } = props

  const [selectedOption, setOptionChequeado] = useState(checked)

  const handleOptionChange = (e) => {
    setOptionChequeado(e.target.value === 'true')
    onChange(e, 'bool')
  }

  return (
    <>
      <RadioButtonButton
        name={name}
        value={true}
        checked={selectedOption ?? false}
        onChange={handleOptionChange}
        disabled={disabled}
      >
        {textOn}
      </RadioButtonButton>
      <RadioButtonButton
        name={name}
        value={false}
        checked={checked !== null ? !selectedOption : false}
        onChange={handleOptionChange}
        disabled={disabled}
      >
        {textOff}
      </RadioButtonButton>
    </>
  )
})

ButtonToggle.propTypes = {
  name: PropTypes.string.isRequired,
  textOn: PropTypes.string.isRequired,
  textOff: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

ButtonToggle.displayName = 'ButtonToggle'

export default ButtonToggle
